<template src="./QuestionsMenu.html" />

<script>
// vuex
import { mapState } from 'vuex';
import gsap from "gsap";
import Analytics from '../../mixins/Analytics';

export default {
  name: "QuestionsMenu",
  data() {
    return {
      ieTriggerTop: false,
      ieTriggerBottom: false
    }
  },
  computed: {
    ...mapState(['currentQuestionId', 'UserAgent', 'Screentest', 'questionsList'])
  },
  methods: {
    scrollToQuestion(index) {
      const scrollPosition =
          document.querySelectorAll('.questions__item')[index].getBoundingClientRect().top
          - document.querySelector('.wrapper_top').clientHeight
          - document.querySelector('.isi__pi').clientHeight
          + window.pageYOffset;

      if(!/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        gsap.to(window, {duration: 1, scrollTo: scrollPosition});
      } else {
        window.scroll(0, scrollPosition);
      }
    },
    fixedMenu() { // ie alternative 'position:sticky'
      if(this.UserAgent.browser.name === 'ie') {
        // DOM elements
        const menu = document.querySelector('.questions_menu');
        const content = document.querySelector('.questions');
        const wrapperTop = document.querySelector('.wrapper_top');
        const introLogo = document.querySelector('.top_screen__logo_brand');

        // calculate on scroll
        document.addEventListener('scroll', () => {
          // sizes and offsets
          const wrapperTopHeight = wrapperTop.clientHeight;
          const introLogoHeight = introLogo.clientHeight;
          const menuHeight = menu.clientHeight;
          const contentOffsetTop = content.getBoundingClientRect().top;
          const contentOffsetBottom = content.getBoundingClientRect().bottom;
          const contentHeight = content.clientHeight;
          const offsetTop = 50;
          const offsetBottom = 150;

          // triggers
          this.ieTriggerTop = (contentOffsetTop - wrapperTopHeight - introLogoHeight - offsetTop) <= 0;
          this.ieTriggerBottom = (contentOffsetBottom - menuHeight - offsetBottom) <= 0;

          // set menu's offset top
          if(this.ieTriggerBottom) {
            menu.style.top = `${contentHeight - menuHeight}px`;
          } else {
            menu.style.top = '';
          }
        });
      }
    }
  },
  mounted() {
    this.fixedMenu(); // init ie alternative 'position:sticky'
  },
  mixins: [Analytics]
}
</script>

<style scoped src="./QuestionsMenu.scss" lang="scss" />
